import { useQuery } from "@tanstack/react-query";
import { getAvailableFunctionalCurrencies } from "api";

export const useAvailableFunctionalCurrenciesQuery = () =>
  useQuery({
    queryKey: ["available-functional-currencies"],
    queryFn: async () => await getAvailableFunctionalCurrencies(),
  });
